import ArticlePage from "@/pages/article/ArticlePage";

export default function ShippingGuide() {
  return <ArticlePage slug="shipping-delivery-guide-vigorbuy" />;
}